import { useEffect, useRef, useState } from 'react'
import type { RefObject } from 'react'
import './TextOverlay.css'

export interface TextPromptState {
  x: number
  y: number
  commit: (text: string) => void
}

interface TextOverlayProps {
  prompt: TextPromptState
  canvasRef: RefObject<HTMLCanvasElement | null>
  onCommit: (text: string) => void
  onCancel: () => void
}

export function TextOverlay({ prompt, canvasRef, onCommit, onCancel }: TextOverlayProps) {
  const [value, setValue] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const id = requestAnimationFrame(() => inputRef.current?.focus())
    return () => cancelAnimationFrame(id)
  }, [])

  const canvas = canvasRef.current
  const rect = canvas?.getBoundingClientRect()
  const scaleX = canvas && rect ? rect.width / canvas.width : 1
  const scaleY = canvas && rect ? rect.height / canvas.height : 1
  const cssX = prompt.x * scaleX
  const cssY = prompt.y * scaleY

  return (
    <div className="text-overlay-wrap">
      <div
        className="text-overlay-box"
        style={{ left: cssX, top: cssY }}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <input
          ref={inputRef}
          autoFocus
          type="text"
          className="text-overlay-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onCommit(value)
            if (e.key === 'Escape') onCancel()
          }}
          placeholder="Type here"
        />
        <div className="text-overlay-actions">
          <button
            type="button"
            className="text-overlay-btn text-overlay-cancel"
            onClick={onCancel}
            aria-label="Cancel text"
          >
            ✕
          </button>
          <button
            type="button"
            className="text-overlay-btn text-overlay-done"
            onClick={() => onCommit(value)}
            aria-label="Add text"
          >
            ✓
          </button>
        </div>
      </div>
    </div>
  )
}
